import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import axios from "axios";
import { Button, Row, Col, Table, Input, Badge, ButtonGroup, Label } from "reactstrap";

// D05/D18 (checklist del 21 OCT 2026)
//  Correos:   evidencia de cada aviso (destinatario, asunto, hora y si SendGrid lo acepto)
//  Auditoria: quien cambio que y cuando, incluidos los intentos bloqueados por permisos
function Bitacoras() {
  const { user } = useContext(AuthContext);
  const URL = process.env.REACT_APP_URL_BITACORAS;
  const hoy = new Date().toISOString().slice(0, 10);
  const hace7 = new Date(Date.now() - 7 * 86400000).toISOString().slice(0, 10);

  const [pestana, setPestana] = useState("correos");
  const [desde, setDesde] = useState(hace7);
  const [hasta, setHasta] = useState(hoy);
  const [texto, setTexto] = useState("");
  const [estado, setEstado] = useState("");
  const [accion, setAccion] = useState("");
  const [soloCriticos, setSoloCriticos] = useState(true);
  const [filas, setFilas] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [abierto, setAbierto] = useState("");

  function carga() {
    setCargando(true);
    const params = new URLSearchParams({ desde, hasta });
    if (texto.trim()) params.set("texto", texto.trim());
    if (pestana === "correos" && estado) params.set("estado", estado);
    if (pestana === "auditoria" && accion) params.set("accion", accion);
    if (pestana === "auditoria" && soloCriticos) params.set("criticos", "Si");
    axios
      .get(`${URL}${pestana === "correos" ? "Correos" : "Auditoria"}?${params.toString()}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setFilas(res.data || []))
      .catch(() => setFilas([]))
      .finally(() => setCargando(false));
  }

  useEffect(() => {
    setFilas([]);
    carga();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pestana]);

  const hora = (f) =>
    f ? new Date(f).toLocaleString("es-MX", { timeZone: "America/Mexico_City", hour12: false }) : "";

  const colorEstado = (e) => (e === "Aceptado" ? "success" : e === "Rechazado" ? "danger" : "warning");
  const colorAccion = (a) =>
    a === "Bloqueado" ? "danger" : a === "Error" ? "warning" : a === "Baja" ? "dark" : a === "Alta" ? "success" : "info";

  if (!(user.usuarios_permisos || user.menu_usuarios)) {
    return (
      <>
        <Header />
        <div className="card container">No tienes acceso a las bitacoras.</div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="card container col-12">
        <h3 align="center">Bitacoras</h3>
        <ButtonGroup className="mb-3">
          <Button
            color={pestana === "correos" ? "primary" : "secondary"}
            title="Cada correo que salio del sistema y si SendGrid lo acepto"
            onClick={() => setPestana("correos")}
          >
            <i class="fas fa-envelope"></i> Correos
          </Button>
          <Button
            color={pestana === "auditoria" ? "primary" : "secondary"}
            title="Quien cambio que y cuando"
            onClick={() => setPestana("auditoria")}
          >
            <i class="fas fa-user-shield"></i> Auditoria
          </Button>
        </ButtonGroup>

        <Row>
          <Col md={2}>
            <Label>Desde</Label>
            <Input type="date" bsSize="sm" value={desde} onChange={(e) => setDesde(e.target.value)} />
          </Col>
          <Col md={2}>
            <Label>Hasta</Label>
            <Input type="date" bsSize="sm" value={hasta} onChange={(e) => setHasta(e.target.value)} />
          </Col>
          <Col md={3}>
            <Label>Buscar</Label>
            <Input
              bsSize="sm"
              placeholder={pestana === "correos" ? "Asunto, correo o evento" : "Usuario, ruta o mensaje"}
              value={texto}
              onChange={(e) => setTexto(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && carga()}
            />
          </Col>
          {pestana === "correos" ? (
            <Col md={2}>
              <Label>Resultado</Label>
              <Input type="select" bsSize="sm" value={estado} onChange={(e) => setEstado(e.target.value)}>
                <option value="">Todos</option>
                <option value="Aceptado">Aceptado</option>
                <option value="Rechazado">Rechazado</option>
                <option value="Enviando">Enviando</option>
              </Input>
            </Col>
          ) : (
            <>
              <Col md={2}>
                <Label>Accion</Label>
                <Input type="select" bsSize="sm" value={accion} onChange={(e) => setAccion(e.target.value)}>
                  <option value="">Todas</option>
                  <option value="Alta">Alta</option>
                  <option value="Cambio">Cambio</option>
                  <option value="Baja">Baja</option>
                  <option value="Archivo">Archivo</option>
                  <option value="Bloqueado">Bloqueado</option>
                  <option value="Error">Error</option>
                </Input>
              </Col>
              <Col md={1} style={{ display: "flex", alignItems: "flex-end" }}>
                <Label check title="Autorizaciones, pagos, permisos, embarques y bancos">
                  <Input
                    type="checkbox"
                    checked={soloCriticos}
                    onChange={(e) => setSoloCriticos(e.target.checked)}
                  />{" "}
                  Criticos
                </Label>
              </Col>
            </>
          )}
          <Col md={2} style={{ display: "flex", alignItems: "flex-end" }}>
            <Button size="sm" color="primary" onClick={carga} disabled={cargando} title="Buscar con estos filtros">
              <i class="fas fa-search"></i> {cargando ? "Buscando..." : "Buscar"}
            </Button>
          </Col>
        </Row>

        <div style={{ fontSize: 12, color: "#64748b", margin: "8px 0" }}>
          {filas.length} registros{filas.length >= 500 ? " (se muestran los 500 mas recientes; acota las fechas)" : ""}
        </div>

        {pestana === "correos" ? (
          <Table size="sm" striped borderless className="table-responsive-xl">
            <thead>
              <tr>
                <th>Fecha y hora</th>
                <th>Evento</th>
                <th>Asunto</th>
                <th>Para</th>
                <th>Copia</th>
                <th>Resultado</th>
              </tr>
            </thead>
            <tbody>
              {filas.map((f) => (
                <tr key={f._id}>
                  <td style={{ whiteSpace: "nowrap" }}>{hora(f.createdAt)}</td>
                  <td style={{ fontSize: 11 }}>{f.origen}</td>
                  <td>{f.asunto}</td>
                  <td style={{ fontSize: 12 }}>{(f.para || []).join(", ")}</td>
                  <td style={{ fontSize: 11, color: "#64748b" }}>{(f.cc || []).join(", ")}</td>
                  <td>
                    <Badge color={colorEstado(f.estado)} pill title={f.error || ""}>
                      {f.estado}
                    </Badge>
                    {f.error ? <div style={{ fontSize: 10, color: "#b91c1c", maxWidth: 260 }}>{f.error}</div> : null}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <Table size="sm" striped borderless className="table-responsive-xl">
            <thead>
              <tr>
                <th>Fecha y hora</th>
                <th>Usuario</th>
                <th>Accion</th>
                <th>Modulo</th>
                <th>Ruta</th>
                <th>Resultado</th>
                <th>Cambios</th>
              </tr>
            </thead>
            <tbody>
              {filas.map((f) => (
                <tr key={f._id}>
                  <td style={{ whiteSpace: "nowrap" }}>{hora(f.createdAt)}</td>
                  <td>
                    {f.nombre || "Sin sesion"}
                    <div style={{ fontSize: 10, color: "#64748b" }}>{f.email}</div>
                  </td>
                  <td>
                    <Badge color={colorAccion(f.accion)} pill>
                      {f.accion}
                    </Badge>
                  </td>
                  <td>{f.recurso}</td>
                  <td style={{ fontSize: 11 }}>
                    {f.metodo} {f.ruta}
                  </td>
                  <td style={{ fontSize: 12 }}>
                    {f.estado}
                    {f.mensaje ? <div style={{ fontSize: 10, color: "#b91c1c", maxWidth: 240 }}>{f.mensaje}</div> : null}
                  </td>
                  <td style={{ maxWidth: 360 }}>
                    {Object.keys(f.cambios || {}).length ? (
                      abierto === f._id ? (
                        <pre
                          style={{ fontSize: 10, whiteSpace: "pre-wrap", margin: 0, cursor: "pointer" }}
                          title="Click para cerrar"
                          onClick={() => setAbierto("")}
                        >
                          {JSON.stringify(f.cambios, null, 1)}
                        </pre>
                      ) : (
                        <span
                          style={{ fontSize: 11, color: "#2563eb", cursor: "pointer" }}
                          title="Ver el detalle de lo que se mando"
                          onClick={() => setAbierto(f._id)}
                        >
                          {Object.keys(f.cambios).slice(0, 6).join(", ")}
                          {Object.keys(f.cambios).length > 6 ? "..." : ""}
                        </span>
                      )
                    ) : (
                      <span style={{ fontSize: 11, color: "#94a3b8" }}>—</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </>
  );
}

export default Bitacoras;
